module.exports = __webpack_public_path__ + "static/media/07_log_view.86da49cb.png";